import axios from "axios";
import { API_PATHS } from "../utils/constants/api.constants";

class ThemeService {
    static getTheme() {
        let api = '';
        let id = localStorage.getItem("id");
          api = id ? API_PATHS.getTheme + '?_id=' + id : API_PATHS.getTheme;
        
        localStorage.removeItem("id");
        return axios
            .get(api)
            .then((response) => {
                if (response.data) {
                    // localStorage.setItem("user", JSON.stringify(response.data));
                }
                return response.data;
            });
    }

    static uploadTheme(item) {
        return axios
            .post(API_PATHS.postTheme,
                item
            )
            .then((response) => {
                if (response.data) {
                    // localStorage.setItem("user", JSON.stringify(response.data));
                }
                return response.data;
            });
    }
    static editTheme(item) {
        let api = '';
        let id = localStorage.getItem("id");
        api = API_PATHS.editTheme + '?id=' + id;
        
        localStorage.removeItem("id");
        return axios
          .put(api,item)
          .then((response) => {
            if (response.data) {
            
            }
            return response.data;
          });
      }

      static enableTheme() {
        let api='';
        let item = JSON.parse(localStorage.getItem("item"));
        let id = localStorage.getItem("id");
        console.log(item)
        api = API_PATHS.editTheme + '?id=' + id;
        return axios
          .put(api,item)
          .then((response) => {
            if (response.data) {
            
            }
            return response.data;
          });
      }



    static removeUserDetails() {
        localStorage.removeItem("user");
    }

    static getUserDetails() {
        return JSON.parse(localStorage.getItem("user"));
    }
}

export default ThemeService;